import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export const markIsFraud = (id: string) => (
  httpServices.post(API_URLS.USER.MARK_IS_FRAUD, { id })
);
export const getUsers = (params: Record<string, any>) => httpServices.get(API_URLS.USER.LIST, { params });
